<template>
  <v-layout align-center wrap mb-5>
    <v-flex xs2 class="text-xs-right">
      <span class="title">Badge Export :</span>
    </v-flex>
    <v-flex xs2 offset-xs1>
      <content-field
        type="password"
        label="Password for archieve"
        v-model="passwordForBadges"
      ></content-field>
    </v-flex>
    <v-flex offset-xs1>
      <v-btn
        dark
        color="green"
        @click="getBadgeArchieve"
      >
        Download
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions } from 'vuex'
// import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ExportBadgesArchieve',
  data () {
    return {
      passwordForBadges: ''
    }
  },
  validations: {
    // passwordForBadges: { required }
  },
  methods: {
    ...mapActions(['exportBadgesArchieve']),
    async getBadgeArchieve () {
      try {
        // this.$v.passwordForBadges.$touch()
        // if (this.$v.passwordForBadges.$invalid) return

        await this.exportBadgesArchieve(this.passwordForBadges)
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/GlobalSettings/ExportBadges.vue